<template lang="pug">
#page_video_list.page
	Banner(v-bind:item='item_landing', classes='list_video external_link')
	.container
		.filters
			h2.title
				p(v-if='$i18n.locale === "tw"') 參展主題
				p(v-else) TAGS
			.item_filter(
				v-for='item in categories',
				v-bind:data-filter='item',
				v-on:click='toggleActive'
			) {{ item }}

		.row
			.col-md-4(v-for='(item, index) in items')
				CardFull(v-bind:item='item', classes='"external_link detail"')
</template>

<script>
import Banner from '@/components/Banner.vue';
import CardFull from '@/components/CardFull.vue';
import TitleStar from '@/components/TitleStar.vue';

export default {
	data() {
		return {
			categories_tw: [
				'小寶貝也看得懂',
				'奇幻心歷險',
				'親情三溫暖',
				'勇氣加值中',
				'陪著你長大',
				'未來旋轉門',
				'翻轉腦細胞',
				'亞太地區',
				'歐洲',
				'美洲',
				'分齡建議4+',
				'分齡建議8+',
				'分齡建議11+',
				'長片',
				'短片',
				'動畫片',
				'劇情片',
				'電視/網路系列節目',
				'紀錄片',
			],
			categories_en: [
				'Tiny Tales for Tiny Tots',
				'Journeys of Fantasy',
				'Our Family Medley',
				'Courageous Me',
				'Growing Together',
				'Future-go-round',
				'Brain Blast',
				'Asia-Pacific',
				'Europe',
				'America',
				'4+',
				'8+',
				'11+',
				'Feature',
				'Short',
				'Animation',
				'Drama',
				'TV/Web Program',
				'Documentary',
			],
			item_landing: {
				media: 'assets/images/topic_banner.png',
				category: this.$t('annual_theme_banner_category'),
				title: this.$t('annual_theme_banner_title'),
				desc: this.$t('annual_theme_banner_desc'),
				link_yt: 'https://www.youtube.com/embed/BDz--NrT9io',
			},
			items: [],
			filters: [],
		};
	},
	methods: {
		refresh: function () {
			let locale = this.$i18n.locale;
			let video_data = require(`@/assets/data/video_${locale}`);
			let videos = video_data.map(item => {
				let image_path =
					item.image !== ''
						? require(`@/assets/images/film_photo/program/${item.id}/${item.image}`)
						: '';
				return {
					...item,
					title: item[`title_${locale}`],
					image: image_path,

					// for cardHover
					brief: item.desc,

					// for cardFull
					// prettier-ignore
					desc: `${item.type[0]} | ${item.film_length} ${this.$t('general_minute')} | ${item.rated}`,
				};
			});
			if (this.filters.length == 0) {
				this.items = videos
					.slice(0)
					.sort((a, b) => Number(a.id) - Number(b.id));
			} else {
				let SET = new Set();
				for (let target of ['category', 'region', 'rated']) {
					videos.forEach(x => {
						if (!SET.has(x.id)) {
							if (this.filters.includes(x[target])) {
								SET.add(x.id);
							}
						}
					});
				}
				videos.forEach(video => {
					for (let type of video.type) {
						// for type of each video
						if (this.filters.includes(type)) SET.add(video.id);
					}
				});

				this.items = videos
					.filter(item => SET.has(item.id))
					.sort((a, b) => Number(a.id) - Number(b.id));
			}
		},
		toggleActive: function (event) {
			event.target.classList.toggle('active');
			this.filters = [];
			document.querySelectorAll('.item_filter.active').forEach(item => {
				this.filters.push(item.textContent);
			});
			this.refresh();
		},
	},
	mounted() {
		this.refresh();
	},
	computed: {
		categories: function () {
			if (this.$i18n.locale === 'en') {
				return this.categories_en;
			} else {
				return this.categories_tw;
			}
		},
	},
	watch: {
		'$i18n.locale'() {
			this.refresh();
			this.item_landing.title = this.$t('annual_theme_banner_title');
			// prettier-ignore
			this.item_landing.category = this.$t('annual_theme_banner_category');

			this.item_landing.desc = this.$t('annual_theme_banner_desc');
		},
	},
	components: {
		Banner,
		CardFull,
		TitleStar,
	},
};
</script>

<style lang="stylus">
#page_video_list
	.title_star
		margin-bottom: 42px
	.text_intro
		text-align: justify
		line-height: 2rem
		color: white
		margin-bottom: 3.5rem
	.filters
		display: flex
		flex-wrap: wrap
		margin-bottom: 4rem
		border-radius: 15px
		background-color: $color_dark
		padding: 24px
		padding-bottom: 0
		.title
			color: white
			text-align: left
			flex-basis: 100%
			margin-bottom: 20px
			line-height: 24px
		.item_filter
			font-size: $fs-4
			color: white
			line-height: 24px
			margin: 0 12px 20px 0
			border-radius: 32px
			border: 1px solid white
			padding: 0.3rem 0.8rem
			font-size: 14px
			user-select: none
			cursor: pointer
			&.active
				color: black
				border-color: $color_yellow
				background-color: $color_yellow
			&:hover
				color: black
				border-color: $color_yellow
				background-color: $color_yellow
	@media screen and (max-width: $screen-sm-max)
		.text
			padding-top: 6rem
</style>
